/*
 * --------------------------------------
 * Copyright (c) 2019 BetterCapital.US
 * --------------------------------------
 */
import React, { Component /* lazy, Suspense  */ } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  Container,
  CardBody,
  Col,
  Row,
  Button,
  Alert,
  FormText,
  FormGroup,
  Label,
  Input /* FormText */
} from "reactstrap";
import isNumber from "../../validation/is-Number";
import { getUserDetail, updateUser } from "../../actions/auth/authAction";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastData: {
        name: "",
        phone: ""
      },
      name: {
        isActive: false,
        isValid: true,
        isTouched: false,
        value: ""
      },
      phone: {
        isActive: false,
        isValid: true,
        isTouched: false,
        value: ""
      },
      currentpassword: {
        isActive: false,
        isValid: false,
        isTouched: false,
        value: ""
      },
      password: {
        isActive: false,
        isValid: false,
        isTouched: false,
        value: ""
      },
      cpassword: {
        isActive: false,
        isValid: false,
        isTouched: false,
        value: ""
      },
      email: {
        isActive: false,
        isValid: false,
        isTouched: false,
        value: ""
      },
      firstTime: true,
      saving: false,
      isFormModified: false,
      serverResponse: "",
      success: false,
      serverResponseStyle: "Success"
    };
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  validateField(fieldName, value) {
    const currentField = this.state[fieldName];

    switch (fieldName) {
      case "name":
        currentField.isValid = value.trim().length > 0;
        break;
      case "currentpassword":
        currentField.isValid = value.trim().length > 0;
        break;
      case "phone":
        currentField.isValid = isNumber(value);
        break;
      case "password":
        currentField.isValid = value.trim().length > 0;
        break;
      case "cpassword":
        currentField.isValid =
          value.trim().length > 0 && value.trim() === this.state.password.value;
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: currentField
    });
  }

  handleFieldsChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      {
        ...this.state,
        serverResponse: "",
        [name]: {
          ...this.state[name],
          value: value,
          isTouched: true,
          isActive: true
        }
      },
      () => {
        this.validateField(name, value);
      }
    );
  };

  handleSave = e => {
    e.preventDefault();
    // this.setState({...this.state, serverResponse: '' })
    //checking if the inputs are valid.
    let isFormValid =
      this.state.name.isValid &&
      ((this.state.name.isActive ? this.state.name.isValid : true) &&
        (this.state.phone.isActive ? this.state.phone.isValid : true) &&
        (this.state.currentpassword.isActive
          ? this.state.currentpassword.isValid
          : true)) &&
      (this.state.password.isActive ? this.state.password.isValid : true) &&
      (this.state.cpassword.isActive ? this.state.cpassword.isValid : true);
    if (isFormValid) {
      let dataToSave = {};
      if (this.state.name.isActive) dataToSave.name = this.state.name.value;
      if (this.state.phone.isActive) dataToSave.phone = this.state.phone.value;
      if (this.state.password.isActive && this.state.currentpassword.isActive) {
        dataToSave.password = this.state.password.value;
        dataToSave.currentpassword = this.state.currentpassword.value;
      }

      //checking if the data has been modified.
      // dataToSave.isModified = tempAsset == modifiedAsset ? false : true;
      let hasDataModified =
        (this.state.phone.isActive
          ? this.state.phone.value !== this.state.lastData.phone
          : false) ||
        (this.state.name.isActive
          ? this.state.name.value !== this.state.lastData.name
          : false) ||
        this.state.password.isActive;
      dataToSave.isModified = hasDataModified;
      if (hasDataModified) {
        //last data
        let lastData = {
          name: this.state.name.value,
          phone: this.state.phone.value
        };
        this.setState(
          {
            ...this.state,
            lastData,
            saving: true,
            isFormModified: false,
            serverResponse: ""
          },
          () => {
            this.props.updateUser(dataToSave);
          }
        );
      } else {
        this.setState({ ...this.state, serverResponse: "No data Modified" });
      }
    } else {
      this.setState({
        ...this.state,
        name: { ...this.state.name, isTouched: true },
        phone: { ...this.state.phone, isTouched: true },
        currentpassword: { ...this.state.currentpassword, isTouched: true },
        password: { ...this.state.password, isTouched: true },
        cpassword: { ...this.state.cpassword, isTouched: true }
      });
    }
  };
  componentDidMount() {
    this.props.getUserDetail();
  }

  componentWillReceiveProps(nextProps) {
    let { user_detail } = nextProps.auth;
    if (nextProps.auth.user_detail) {
      let data = {
        name: user_detail.fullName,
        phone: user_detail.phone
      };
      this.setState(
        {
          lastData: data,
          firstTime: false,
          // serverResponse: nextProps.auth.serverResp ? nextProps.auth.serverResp : this.state.serverResponse,
          name: {
            ...this.state.name,
            value: this.state.firstTime
              ? user_detail.fullName
              : this.state.name.value
          },
          phone: {
            ...this.state.phone,
            value: this.state.firstTime
              ? user_detail.phone
              : this.state.phone.value
          },
          email: {
            ...this.state.email,
            value: this.state.firstTime
              ? user_detail.email
              : this.state.email.value
          }
        },
        () => {
          // if (nextProps.auth.loading) {
          //     this.setState({ ...this.state, saving: true });
          // }
        }
      );
    }
    if (nextProps.auth.userUpdateSuccess) {
      // if(nextProps.auth.serverResp !== "User Updated Successful")
      // this.setState({serverResponseStyle : 'Danger'})
      this.setState({
        ...this.state,
        saving: false,
        serverResponse: nextProps.auth.serverResp
      });
    }
  }

  render() {
    const {
      name,
      email,
      phone,
      currentpassword,
      password,
      cpassword
    } = this.state;
    return (
      <Container className="dashboard">
        <Row>
          <Col md={8}>
            <h3 className="page-title">Settings</h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <CardBody>
              <Col md={12}>
                {this.state.serverResponse !== "" && (
                  <Alert color={this.state.serverResponseStyle}>
                    {this.state.serverResponse}
                  </Alert>
                )}
                <FormGroup row>
                  <Col sm={6}>
                    <Label>Name:</Label>
                    <Input
                      type="text"
                      onChange={this.handleFieldsChange}
                      name="name"
                      value={name.value}
                    />
                    {name.isTouched && !name.isValid && (
                      <FormText color="danger">Name is required.</FormText>
                    )}
                  </Col>
                  <Col sm={6}>
                    <Label>Phone:</Label>
                    <Input
                      type="text"
                      name="phone"
                      onChange={this.handleFieldsChange}
                      value={phone.value}
                    />
                    {phone.isTouched && !phone.isValid && (
                      <FormText color="danger">
                        {" "}
                        10 Digits Phone Number required.
                      </FormText>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label>Email:</Label>
                    <Input
                      type="text"
                      readOnly
                      name="phone"
                      onChange={this.handleFieldsChange}
                      value={email.value}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label>Current Password</Label>
                    <Input
                      type="password"
                      name="currentpassword"
                      onChange={this.handleFieldsChange}
                      placeholder="Current Password"
                      value={currentpassword.value}
                    />
                    {/* {(currentpassword.isTouched && !currentpassword.isValid) && <FormText color="danger">Current Password is required.</FormText>} */}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label>New Password</Label>
                    <Input
                      type="password"
                      name="password"
                      onChange={this.handleFieldsChange}
                      placeholder="Password"
                      value={password.value}
                    />
                    {/* {(password.isTouched && !password.isValid) && <FormText color="danger">Password is required.</FormText>} */}
                  </Col>
                  <Col sm={6}>
                    <Label>Confirm Password:</Label>
                    <Input
                      type="password"
                      name="cpassword"
                      onChange={this.handleFieldsChange}
                      placeholder="Confirm Password"
                      value={cpassword.value}
                    />
                    {password.value.trim().length !== 0 &&
                      password.isTouched &&
                      !cpassword.isValid && (
                        <FormText color="danger">
                          Confirm Password Must be save.
                        </FormText>
                      )}
                  </Col>
                </FormGroup>
                <div className="text-right">
                  {!this.state.saving && (
                    <Button color="success" onClick={this.handleSave}>
                      Save
                    </Button>
                  )}
                  {this.state.saving && (
                    <Button color="success">Saving </Button>
                  )}
                </div>
              </Col>
              {/* </Row> */}
              {/* </Col> */}
            </CardBody>
          </Col>
        </Row>
      </Container>
    );
  }
}
function mapStateToProps(state) {
  return {
    auth: state.userDetail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserDetail: () => getUserDetail(dispatch),
    updateUser: userData => updateUser(userData, dispatch)
  };
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Settings)
);
